import React, { useState } from "react";

interface InquiryModalProps {
  show: boolean;
  onClose: () => void;
  inquiryData: {
    tripType?: string;    
    type: "Flight" | "Hotel" | "Package" | "Insurance";
    nameOfItem?: string;
    from?: string;
    to?: string;
    date?: string;
    checkin?: string;
    checkout?: string;
    adults?: number;
    children?: number;
    name: string;
    email: string;
    phone: string;
    returnDate?: string;   // ✅ add this

  };
}

const InquiryModal: React.FC<InquiryModalProps> = ({ show, onClose, inquiryData }) => {
  const [formData, setFormData] = useState({
    name: inquiryData.name || "",
    email: inquiryData.email || "",
    phone: inquiryData.phone || "",
    message: "",
    checkin: inquiryData.checkin || "",
    checkout: inquiryData.checkout || "",
    adults: inquiryData.adults?.toString() || "1",
    children: inquiryData.children?.toString() || "0",
    nameOfItem: inquiryData.nameOfItem || "",
    tripType: inquiryData.tripType || "",    // ✅ Added
    returnDate: inquiryData.returnDate || "" // ✅ Added

  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  if (!show) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    // Phone validation (digits only, allow +, min length 8)
    const phoneRegex = /^\+?\d{8,15}$/;
    if (!phoneRegex.test(formData.phone)) {
      return "Please enter a valid phone number (8–15 digits, optional +).";
    }

    // Date validation for Hotel/Package
    if (inquiryData.type === "Hotel" || inquiryData.type === "Package") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const checkinDate = formData.checkin ? new Date(formData.checkin) : null;
      const checkoutDate = formData.checkout ? new Date(formData.checkout) : null;

      if (!checkinDate || !checkoutDate) {
        return "Please select both check-in and check-out dates.";
      }

      if (checkinDate < today) {
        return "Check-in date must be today or in the future.";
      }

      if (checkoutDate <= checkinDate) {
        return "Check-out date must be after check-in date.";
      }
    }

    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    // Validate before sending
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      setLoading(false);
      return;
    }

    try {
      const res = await fetch("https://www.dreamstriphub.com/api/inquiries.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
       body: JSON.stringify({
        type: inquiryData.type,
        nameOfItem: formData.nameOfItem,
        fromLocation: inquiryData.from || "",
        toLocation: inquiryData.to || "",
        travelDate: inquiryData.date || "",
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        checkinDate: formData.checkin || "",
        checkoutDate: formData.checkout || "",
        adults: formData.adults,
        children: formData.children,
        returnDate: inquiryData.returnDate || "",  // ✅ NEW FIELD
        tripType: inquiryData.tripType || "OneWay" // ✅ NEW FIELD
      }),
      });

      const json = await res.json();

      if (!res.ok || !json.success) {
        throw new Error(json.error || "Failed to send inquiry");
      }

      setSuccess(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        checkin: "",
        checkout: "",
        adults: "1",
        children: "0",
        nameOfItem: "",
        tripType: "",     // ✅ Required
  returnDate: ""    // ✅ Required
      });
      onClose();
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "2rem",
          maxWidth: "500px",
          width: "90%",
          position: "relative",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "transparent",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        <h2 style={{ marginBottom: "1rem" }}>
          {inquiryData.type} Inquiry{" "}
          {inquiryData.nameOfItem ? `- ${inquiryData.nameOfItem}` : ""}
        </h2>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {/* Flight Route Info */}
         {/* Flight Route Info */}
{inquiryData.type === "Flight" && (
  <>
    <div>
      <label style={{ fontWeight: "bold" }}>Route</label>
      <input
        type="text"
        value={`${inquiryData.from} → ${inquiryData.to}`}
        readOnly
        style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>
    <div>
      <label style={{ fontWeight: "bold" }}>Departure Date</label>
      <input
        type="date"
        value={inquiryData.date}
        readOnly
        style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
      />
    </div>
    {inquiryData.returnDate && (
      <div>
        <label style={{ fontWeight: "bold" }}>Return Date</label>
        <input
          type="date"
          value={inquiryData.returnDate}
          readOnly
          style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
        />
      </div>
    )}
  </>
)}


          {/* Hotel / Package Info */}
          {(inquiryData.type === "Hotel" || inquiryData.type === "Package") && (
            <>
              <div>
                <label style={{ fontWeight: "bold" }}>Check-in Date</label>
                <input
                  type="date"
                  name="checkin"
                  value={formData.checkin}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Check-out Date</label>
                <input
                  type="date"
                  name="checkout"
                  value={formData.checkout}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Adults</label>
                <input
                  type="number"
                  name="adults"
                  min="1"
                  value={formData.adults}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label style={{ fontWeight: "bold" }}>Children</label>
                <input
                  type="number"
                  name="children"
                  min="0"
                  value={formData.children}
                  onChange={handleChange}
                  style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
            </>
          )}

          {/* Common User Info */}
          <div>
            <label style={{ fontWeight: "bold" }}>Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
            />
          </div>

          <div>
            <label style={{ fontWeight: "bold" }}>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
            />
          </div>

          <div>
            <label style={{ fontWeight: "bold" }}>Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
            />
          </div>

          <div>
            <label style={{ fontWeight: "bold" }}>Message</label>
            <textarea
              name="message"
              placeholder="Comments..."
              rows={4}
              value={formData.message}
              onChange={handleChange}
              style={{ width: "100%", padding: "0.8rem", borderRadius: "6px", border: "1px solid #ccc" }}
            />
          </div>

          {/* Read-only Name of Item */}
          <div>
            <label style={{ fontWeight: "bold" }}>Name of {inquiryData.type}</label>
            <input
              type="text"
              name="nameOfItem"
              value={formData.nameOfItem}
              readOnly
              style={{
                width: "100%",
                padding: "0.8rem",
                borderRadius: "6px",
                border: "1px solid #ccc",
                backgroundColor: "#f5f5f5",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "0.8rem",
              backgroundColor: "#285AEB",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {loading ? "Sending..." : "Send Inquiry"}
          </button>
        </form>

        {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}
        {success && <p style={{ color: "green", marginTop: "1rem" }}>✅ Inquiry sent successfully!</p>}
      </div>
    </div>
  );
};

export default InquiryModal;
